import { ShieldOff } from "lucide-react";
import { type ComponentType } from "react";
import { useHasPermission } from "./useHasPermission";

const NoPermission = () => (
  <div className="flex flex-col items-center justify-center h-64 gap-3 text-muted-foreground">
    <ShieldOff className="w-10 h-10 opacity-40" />
    <p className="text-sm font-medium">You don't have permission to access this page.</p>
  </div>
);

/**
 * HOC that protects a component with RBAC. Renders an inline access-denied
 * message when the user lacks the required permission — no redirect so the
 * URL stays put and the user understands why the page is blank.
 */
export function withRBAC<P extends object>(
  WrappedComponent: ComponentType<P>,
  permission: string,
) {
  return function ProtectedComponent(props: P) {
    const { hasPermission, isLoading } = useHasPermission(permission);

    if (isLoading) return null;
    if (!hasPermission) return <NoPermission />;

    return <WrappedComponent {...props} />;
  };
}
